var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "사업안내",
            "tabActive": "공급안내",
            "bg": "/images/sub/business/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("사업안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("공급안내")];
      },
      proxy: true
    }])
  }, [_c('sheet-tertiary', [_c('v-row', {
    staticClass: "row--lg",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('chip-primary', {
    staticClass: "w-md-140px"
  }, [_vm._v("공급위치")])], 1), _c('v-col', [_c('txt-quarternary', [_vm._v("서울특별시 광진구 자양동 8-8외 3필지 (2호선, 7호선 건대입구역 6번출구)")])], 1)], 1), _c('v-row', {
    staticClass: "row--lg mt-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('chip-primary', {
    staticClass: "w-md-140px"
  }, [_vm._v("공급규모")])], 1), _c('v-col', [_c('txt-quarternary', [_vm._v("공동주택 지하 5층~지상 최고 24층 1개동 총 480세대 중 민간임대 313세대(특별공급 63세대, 일반공급 250세대) 공급")])], 1)], 1), _c('v-row', {
    staticClass: "row--lg mt-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('chip-primary', {
    staticClass: "w-md-140px"
  }, [_vm._v("공급대상")])], 1), _c('v-col', [_c('txt-quarternary', [_vm._v("민간임대 313세대(특별공급 63세대, 일반공급 250세대)")])], 1)], 1)], 1), _c('div', {
    staticClass: "v-data-table v-data-table--border v-data-table--line v-data-table--density-comfortable mt-40px mt-md-60px"
  }, [_c('div', {
    staticClass: "v-data-table__wrapper"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("공급 "), _c('br'), _vm._v("유형")]), _c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("주거"), _c('br'), _vm._v("전용"), _c('br'), _vm._v("(타입)")]), _c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("공급"), _c('br'), _vm._v("호수")]), _c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("특별"), _c('br'), _vm._v("공급")]), _c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("일반"), _c('br'), _vm._v("공급")]), _c('th-primary', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("세대당 계약면적(㎡)")]), _c('th-primary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("발코니"), _c('br'), _vm._v("확장면적"), _c('br'), _vm._v("(㎡)")])], 1), _c('tr', [_c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("주거전용")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("주거공용")]), _c('th-secondary', {
    staticClass: "border-r-white"
  }, [_vm._v("기타공용"), _c('br'), _c('span', {
    staticClass: "font-size-12 font-weight-regular"
  }, [_vm._v("(*주차장 면적 포함)")])]), _c('th-secondary', [_vm._v("합계")])], 1)]), _c('tbody', [_c('tr', {
    staticClass: "table-head-divider"
  }, [_c('th-secondary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("청년형")]), _c('td-primary', [_vm._v("25A")]), _c('td-primary', [_vm._v("71")]), _c('td-primary', [_vm._v("14")]), _c('td-primary', [_vm._v("57")]), _c('td-primary', [_vm._v("20.17")]), _c('td-primary', [_vm._v("13.60")]), _c('td-primary', [_vm._v("13.13")]), _c('td-primary', [_vm._v("46.90")]), _c('td-primary', [_vm._v("5.63")])], 1), _c('tr', {
    staticClass: "table-divider"
  }, [_c('td-primary', [_vm._v("25B")]), _c('td-primary', [_vm._v("198")]), _c('td-primary', [_vm._v("40")]), _c('td-primary', [_vm._v("158")]), _c('td-primary', [_vm._v("20.40")]), _c('td-primary', [_vm._v("13.76")]), _c('td-primary', [_vm._v("13.29")]), _c('td-primary', [_vm._v("47.45")]), _c('td-primary', [_vm._v("5.25")])], 1), _c('tr', [_c('th-secondary', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("신혼부부형"), _c('br'), _vm._v("(예비신혼 포함)")]), _c('td-primary', [_vm._v("52A")]), _c('td-primary', [_vm._v("16")]), _c('td-primary', [_vm._v("3")]), _c('td-primary', [_vm._v("13")]), _c('td-primary', [_vm._v("41.25")]), _c('td-primary', [_vm._v("27.82")]), _c('td-primary', [_vm._v("26.86")]), _c('td-primary', [_vm._v("95.93")]), _c('td-primary', [_vm._v("11.29")])], 1), _c('tr', [_c('td-primary', [_vm._v("52B")]), _c('td-primary', [_vm._v("28")]), _c('td-primary', [_vm._v("6")]), _c('td-primary', [_vm._v("22")]), _c('td-primary', [_vm._v("42.17")]), _c('td-primary', [_vm._v("28.44")]), _c('td-primary', [_vm._v("27.46")]), _c('td-primary', [_vm._v("98.07")]), _c('td-primary', [_vm._v("10.50")])], 1), _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("합계")]), _c('td-primary', [_vm._v("313")]), _c('td-primary', [_vm._v("63")]), _c('td-primary', [_vm._v("250")]), _c('td-primary'), _c('td-primary'), _c('td-primary'), _c('td-primary'), _c('td-primary')], 1)])])])]), _c('sheet-primary', {
    staticClass: "mt-40px mt-lg-60px"
  }, [_c('txt-quarternary', {
    staticClass: "grey--text text--lighten-1 line-height-17"
  }, [_c('v-row', [_vm._l(_vm.items, function (item, index) {
    return [_c('v-col', {
      key: index,
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "dot"
    }, [_vm._v(" " + _vm._s(item) + " ")])])];
  })], 2)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }